module.exports = __webpack_public_path__ + "img/ignis-gls-plus-gris-acero.3c81d703.png";